import Tag from 'packages/ui/Components/Tag'
import { useTranslation } from 'react-i18next'

export const TagAdvertisements = ({ status, fontSize }) => {
  const { t } = useTranslation()

  if (status === 'past') {
    return <Tag status={t('advertisements.status.past')} color={'#DC2626'} bgcolor={'#FEF2F2'} fontSize={fontSize} />
  }
  if (status === 'future') {
    return <Tag status={t('advertisements.status.future')} color={'#3B82F6'} bgcolor={'#EFF5FF'} fontSize={fontSize} />
  }
  return <Tag status={t('advertisements.status.current')} color={'#698F3D'} bgcolor={'#F4F8ED'} fontSize={fontSize} />
}
